<template lang="pug">
    .map-box(v-if="token")
        transition(name="fade")
            .mapLayer(v-if="showOverlay")
                p.info.h-full.flex.items-center.justify-center STRG + Mausrad für Zoom
        MglMap(
            :access-token="token"
            :map-style="style"
            :center="center"
            :bearing="bearing"
            :zoom="zoom"
            :max-zoom="18"
            :min-zoom="3"
            :pitch="40"
            @load="loaded"
            :scrollZoom="false"
        )
            MglMarker(v-for="store in stores" :key="store.key" :coordinates="store.coordinates")
                a.logo-marker(slot="marker" @click="resolve(store.key)") 
                    i.fas.fa-map-marker
</template>

<script>
import _ from "lodash";

import mapboxgl from "mapbox-gl";
import MultiTouch from "mapbox-gl-multitouch";
import { MglMap, MglMarker } from "vue-mapbox";

import { mapGetters } from "vuex";

import router from "@/router";

export default {
  name: "MapBox",
  data: () => ({
    showOverlay: false
  }),
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  components: {
    MglMap,
    MglMarker
  },
  computed: {
    style() {
      let style = "mapbox://styles/vanameland/ckirockk106341ao7dv35bc1p";
      return style;
    },
    stores() {
      return [
        { key: "main", coordinates: [7.566615935357117, 51.4409809924335] } // Schwerte
      ];
    },
    center() {
      return [7.566615935357117, 51.4409809924335];
    },
    zoom() {
      return 12;
    },
    bearing() {
      return -40;
    },
    ...mapGetters({
      token: "mapboxKey"
    })
  },
  methods: {
    keyPressed(event) {
      console.log(event);
    },
    resolve(key) {
      const resolved = this.$router.resolve(key);
      const name = _.get(resolved, "route.name");
      if (name && name !== "Page Not Found") {
        router.push(key);
      }
    },
    async loaded(event) {
      let bounds = new mapboxgl.LngLatBounds();
      this.stores.forEach(store => bounds.extend(store.coordinates));

      let map = event.map;
      map.on("wheel", event => {
        if (event.originalEvent.ctrlKey) {
          // Check if CTRL key is pressed
          this.showOverlay = false;
          event.originalEvent.preventDefault(); // Prevent chrome/firefox default behavior
          if (!map.scrollZoom._enabled) map.scrollZoom.enable(); // Enable zoom only if it's disabled
        } else {
          if (map.scrollZoom._enabled) map.scrollZoom.disable(); // Disable zoom only if it's enabled
        }
      });
      map.fitBounds(
        bounds,
        {
          padding: 40,
          bearing: 0,
          pitch: 0,
          maxZoom: 18,
          duration: 5000
        },
        {
          breakonfitbounds: true
        }
      );

      let timeout,
        reset = false;
      map.on("moveend", event => {
        if (timeout) clearTimeout(timeout);
        if (event.breakonfitbounds || reset) {
          reset = true;
          timeout = setTimeout(() => {
            map.easeTo({ pitch: 0, bearing: 0 });
            reset = false;
          }, 100);
        }
      });
      map.once("mouseover", () => {
        this.showOverlay = true;
      });
      map.on("move", () => {
        if (timeout) clearTimeout(timeout);
      });

      // map.dragPan.disable();
      // map.scrollZoom.disable();

      // map.on('touchstart', event => {
      //     const e = event.originalEvent;
      //     if (e && 'touches' in e) {
      //         if (e.touches.length > 1) {
      //             map.dragPan.enable();
      //         } else {
      //             map.dragPan.disable();
      //         }
      //     }
      // });

      map.addControl(new MultiTouch());

      // Here we cathing 'load' map event
      // const asyncActions = event.component.actions

      // const newParams = await asyncActions.flyTo({
      //     center: [30, 30],
      //     zoom: 9,
      //     speed: 1
      // })
      // console.log(newParams)
    }
  }
};
</script>

<style lang="sass" scoped>

@import '~@/assets/sass/variables'

#app
    .map-box
        height: 400px
        position: relative
        .mapLayer
            position: absolute
            width: 100%
            height: 100%
            top: 0
            left: 0
            background-color: rgb(145, 145, 145, 0.4)
            z-index: 2
            pointer-events: none
            .info
                @apply text-white text-6xl
    .logo-marker.mapboxgl-marker
        i
            font-size: 48px
            color: $etori-sec
</style>
